export const isPhoneNumberValid = value => {
  return /^\+?\d{8,16}$/.test(value)
}
export const isPhoneNumberValidWatcher = value => {
  return /^\+?\d{0,5}$/.test(value)
}
